!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r(require("classnames"), require("prop-types"), require("react")) : "function" == typeof define && define.amd ? define(["classnames", "prop-types", "react"], r) : "object" == typeof exports ? exports.MaterialIcon = r(require("classnames"), require("prop-types"), require("react")) : e.MaterialIcon = r(e.classnames, e["prop-types"], e.react);
}(this, function (e, r, t) {
  return function (e) {
    function r(i) {
      if (t[i]) return t[i].exports;
      var o = t[i] = {
        exports: {},
        id: i,
        loaded: !1
      };
      return e[i].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
    }
    var t = {};
    return r.m = e, r.c = t, r.p = "", r(0);
  }([function (e, r, t) {
    "use strict";

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(r, "__esModule", {
      value: !0
    }), r.MaterialIconStack = void 0;
    var o = t(4),
      d = i(o),
      l = t(5),
      a = i(l);
    r.default = d.default, r.MaterialIconStack = a.default;
  }, function (e, r) {
    e.exports = require("classnames");
  }, function (e, r) {
    e.exports = require("prop-types");
  }, function (e, r) {
    e.exports = require("react");
  }, function (e, r, t) {
    "use strict";

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var d = t(3),
      l = i(d),
      a = t(2),
      u = i(a),
      n = t(1),
      c = i(n),
      s = [2, 3, 4, 5],
      f = [1, 2],
      p = ["left", "right"],
      m = [90, 180, 270],
      v = ["horizontal", "vertical"],
      b = function b(e) {
        var r,
          t = e.type,
          i = e.large,
          d = void 0 !== i && i,
          a = e.size,
          u = void 0 === a ? 1 : a,
          n = e.stackSize,
          b = void 0 === n ? 0 : n,
          x = e.fixed,
          z = void 0 !== x && x,
          h = e.list,
          y = void 0 !== h && h,
          _ = e.border,
          g = void 0 !== _ && _,
          q = e.borderCircle,
          M = void 0 !== q && q,
          O = e.pull,
          j = void 0 === O ? "" : O,
          k = e.spin,
          I = void 0 !== k && k,
          P = e.reverse,
          S = void 0 !== P && P,
          w = e.rotate,
          C = void 0 === w ? 0 : w,
          E = e.flip,
          N = void 0 === E ? "" : E,
          R = (r = {
            zmdi: !0
          }, o(r, "zmdi-" + t, !0), o(r, "zmdi-hc-lg", d), o(r, "zmdi-hc-fw", z), o(r, "zmdi-hc-li", y), o(r, "zmdi-hc-border", g), o(r, "zmdi-hc-border-circle", M), o(r, "zmdi-hc-spin", I), o(r, "zmdi-hc-spin-reverse", I && S), o(r, "pull-" + j, p.indexOf(j) > -1), o(r, "zmdi-hc-" + u + "x", !d && s.indexOf(u) > -1), o(r, "zmdi-hc-stack-" + u + "x", !d && f.indexOf(b) > -1), o(r, "zmdi-hc-rotate-" + C, m.indexOf(C) > -1), o(r, "zmdi-hc-flip-" + N, v.indexOf(N) > -1), r);
        return l.default.createElement("i", {
          className: (0, c.default)(R)
        });
      };
    b.propTypes = {
      type: u.default.string.isRequired,
      large: u.default.bool,
      size: u.default.number,
      stackSize: u.default.number,
      fixed: u.default.bool,
      list: u.default.bool,
      border: u.default.bool,
      borderCircle: u.default.bool,
      pull: u.default.string,
      spin: u.default.bool,
      reverse: u.default.bool,
      flip: u.default.string,
      rotate: u.default.number
    }, r.default = b;
  }, function (e, r, t) {
    "use strict";

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var o = t(3),
      d = i(o),
      l = t(2),
      a = i(l),
      u = t(1),
      n = i(u),
      c = function c(e) {
        var r = e.children,
          t = e.large,
          i = {
            "zmdi-hc-stack": !0,
            "zmdi-hc-lg": t
          };
        return d.default.createElement("span", {
          className: (0, n.default)(i)
        }, r);
      };
    c.propTypes = {
      children: a.default.any.isRequired,
      large: a.default.bool
    }, r.default = c;
  }]);
});